import React, { FC, HTMLAttributes } from 'react';
import { Typography } from '@mui/material';
import { EMenuIcon } from '../types';
import { MENU_ITEM_ICONS } from '../constants';

interface IProps extends HTMLAttributes<HTMLLIElement> {
  icon: EMenuIcon;
}

export const IconOptionLabel: FC<IProps> = ({ icon, ...props }) => {
  const Icon = MENU_ITEM_ICONS[icon];

  return (
    <li {...props}>
      <Typography>
        <Icon />

        {icon}
      </Typography>
    </li>
  );
};
